import Vue from 'vue'
import Vuex from 'vuex'
import cookies from '@/libs/util.cookies'
import request from '@/libs/request'
import { States, UserRegister, UserLogin, SwapToken, UserInfo, ModifyUser } from '@/api/account'

Vue.use(Vuex)

function onLogin (state, res) {
  const expire = new Date();
  state.loginTime = expire.getTime();
  expire.setTime(res.expires_in * 1000);
  const setting = {
    expires: expire
  };
  cookies.set('token', res.access_token, setting)
  cookies.set('token-expires', res.expires_in)
  cookies.set('token-type', res.token_type);
}

export default new Vuex.Store({
  state: {
    userinfo: null,
    headImg: null,
    local_info: JSON.parse(window.localStorage.getItem('login_info')),
    locale: 'zh-TW',
    // 地区码
    states: null,
    areas: null,
    // 邮政编码
    postcode: null,
    // 收货地址
    addresses: null,
    // 最后下单的订单id
    pay_order_id: parseInt(window.localStorage.getItem('pay_order_id')),
    loadingText: 'Loading...',
    // 是否处于Soga浏览器中
    // onSoga: !!(window && window.HTMLOBJ)
    metaInfo: {
      title: '',
      keywords: '',
      description: '',
      ogTitle: '',
      ogDescription: '',
      ogImage: ''
    }
  },
  getters: {
    // 是否处于Soga浏览器中
    inSoga (state) {
      return !!(window && window.HTMLOBJ);
    },
    userHead (state) {
      const user = state.userinfo;
      if (state.headImg === null && user && user.head) {
        if (user.head) {
          state.headImg = user.head;
          return state.headImg;
        }
      }
      let src = require('@/assets/unknown.png');
      if (user) {
        switch (user.sex) {
          case 0:
            src = require('@/assets/male.png');
            break;
          case 1:
            src = require('@/assets/female.png');
            break;
        }
      }
      state.headImg = src;
      return src;
    }
  },
  mutations: {
    setLoading (state, text) {
      state.loadingText = text;
    },
    setLocale (state, locale) {
      if (locale === 'zh-cn') {
        locale = 'zh-CN';
      } else {
        // 默认繁中
        locale = 'zh-TW';
      }
      state.locale = locale;
    },
    setLocalInfo (state, data) {
      state.local_info = data;
      window.localStorage.setItem('login_info', JSON.stringify(data));
    },
    setPayOrderID (state, id) {
      if (typeof id === 'string') {
        id = parseInt(id);
      }
      if (typeof id !== 'number') {
        return;
      }
      state.pay_order_id = id;
      window.localStorage.setItem('pay_order_id', '' + id);
    },
    logout (state) {
      cookies.remove('token');
      cookies.remove('token-expires');
      cookies.remove('token-type');
      state.userinfo = null;
      state.headImg = null;
      state.loginTime = 0;
    },
    clearHead (state) {
      if (!state.userinfo || state.userinfo.head !== state.headImg) {
        state.headImg = '';
      }
    },
    setMetaInfo (state, metaInfo) {
      if (metaInfo.title) {
        state.metaInfo.title = metaInfo.title
      }
      if (metaInfo.keywords) {
        state.metaInfo.keywords = metaInfo.keywords
      }
      if (metaInfo.description) {
        state.metaInfo.description = metaInfo.description
      }
      if (metaInfo.ogTitle) {
        state.metaInfo.ogTitle = metaInfo.ogTitle
      }
      if (metaInfo.ogDescription) {
        state.metaInfo.ogDescription = metaInfo.ogDescription
      }
      if (metaInfo.ogImage) {
        state.metaInfo.ogImage = metaInfo.ogImage
      }
    },
    setPostcode (state, postcode) {
      state.postcode = postcode;
    }
  },
  actions: {
    // 获取国际区域码
    loadStates ({ state }) {
      return new Promise((resolve, reject) => {
        States().then(async res => {
          state.states = res.detail;
          resolve(res.detail)
        }).catch(err => {
          // console.log('err: ', err);
          reject(err)
        });
      })
    },
    // 获取地区码
    loadAreas ({ state }) {
      return new Promise((resolve, reject) => {
        request({
          url: '/areas',
          method: 'get'
        }).then(async res => {
          state.areas = res;
          resolve(res);
        }).catch(err => {
          // console.log('err: ', err);
          reject(err)
        });
      })
    },
    // 获取邮政编码
    loadPostcode ({ commit }) {
      return new Promise((resolve, reject) => {
        request({
          url: '/area/postcodes',
          method: 'get'
        }).then(async res => {
          commit('setPostcode', res);
          resolve();
        }).catch(err => {
          // console.log('err: ', err);
          reject(err)
        });
      })
    },
    // 获取收货地址
    loadAddresses ({ state }) {
      return new Promise((resolve, reject) => {
        request({
          url: '/v1/user/addresses',
          method: 'get'
        }).then(async res => {
          state.addresses = res.data;
          resolve(res.data)
        }).catch(err => {
          // console.log('err: ', err);
          reject(err)
        });
      })
    },
    register ({ state, dispatch }, {
      stateCode,
      mobile,
      password,
      code
    } = {}) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        UserRegister({
          state_code: stateCode,
          mobile,
          password,
          code,
          trial: 2 // 免费用户
        }).then(async res => {
          onLogin(state, res)
          await dispatch('load')
          // 结束
          resolve()
        }).catch(err => {
          // console.log('err: ', err);
          reject(err)
        });
      })
    },
    /**
     * @description 登录
     * @param {Object} dispatch
     * @param stateCode 国家码
     * @param mobile 手机号
     * @param password 密码
     */
    login ({ state, dispatch }, {
      stateCode,
      mobile,
      password
    } = {}) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        UserLogin({
          state_code: stateCode,
          mobile,
          password
        }).then(async res => {
          onLogin(state, res)
          // 设置 vuex 用户信息
          // 用户登录后从持久化数据加载一系列的设置
          await dispatch('load')
          // 结束
          resolve()
        }).catch(err => {
          // console.log('err: ', err);
          reject(err)
        })
      })
    },

    swapToken ({ state, dispatch }, { token }) {
      return new Promise((resolve, reject) => {
        // console.log('请求：token', token)
        // 开始请求登录接口
        SwapToken({
          token
        }).then(async res => {
          onLogin(state, res)
          // 设置 vuex 用户信息
          // 用户登录后从持久化数据加载一系列的设置
          await dispatch('load')
          // 结束
          resolve()
        }).catch(err => {
          // console.log('err: ', err);
          reject(err)
        })
      })
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     * @param {Object} dispatch vuex dispatch
     */
    load ({ state, dispatch }) {
      return new Promise((resolve, reject) => {
        UserInfo().then(async res => {
          // 设置 vuex 用户信息
          state.userinfo = res;
            // 结束
          resolve();
        }).catch(err => {
          // console.log('err: ', err);
          reject(err);
        })
      })
    },
    modifyUser ({ state, dispatch }, user) {
      return new Promise((resolve, reject) => {
        ModifyUser(user).then(async res => {
          // 更新用户信息
          state.userinfo.nick = res.nick;
          state.userinfo.realname = res.realname;
          state.userinfo.birthday = res.birthday;
          state.userinfo.sex = res.sex;
          state.userinfo.areas = res.areas;
          resolve(state.userinfo);
        }).catch(err => {
          // console.log('err: ', err);
          reject(err);
        })
      })
    }
  },
  modules: {
  }
})
